<script>
    export let title;
    export let action;
</script>

<li on:click={action}>
    <div><h1>{title}</h1></div>
</li>

<style>
    li {
        display: inline-block;
        cursor: default;
        box-shadow: calc(var(--chrome-depth) * 2) calc(var(--chrome-depth) * 2)
            rgba(0, 0, 0, 0.5);
    }

    div {
        padding: 3px 6px;
        background: var(--chrome-hsl);
        border-top: var(--border-color-light) var(--chrome-depth) outset;
        border-right: var(--border-color-dark) var(--chrome-depth) outset;
        border-left: var(--border-color-light) var(--chrome-depth) outset;
        border-bottom: var(--border-color-dark) var(--chrome-depth) outset;
    }

    div:active {
        filter: brightness(0.75);
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
    }
</style>
